<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-toolbar
        flat
        class="mb-4"
        >
            <v-toolbar-title>
                <span v-if="isPersonal" class="text-h5">{{ $t('contacts.columns.personalTags') }}</span>
                <span v-else class="text-h5">{{ $t('contacts.columns.tags') }}</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-text-field
              :label="$t('contacts.tagForm.name')"
              v-if="localTag"
              v-model="localTag.name"
              :rules="nameRules"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="close()"
          >
            {{ $t('contacts.btn.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            :disabled="!valid"
            @click="submit()"
          >
            {{ isUpdate ? $t('contacts.btn.update') : $t('contacts.btn.create') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contacts-tag-form',
  data () {
    return {
      localTag: null,
      originalName: null,
      valid: false,
      nameRules: [
        v => !!v || this.$t('contacts.formValidation.required'),
        v => /^[A-Za-z]+$/.test(v) || this.$t('contacts.formValidation.lettersOnly'),
        v => (v && v.length > 1) || this.$t('contacts.formValidation.minimumChar', { min: 2 })
      ]
    }
  },
  computed: {
    ...mapGetters({
      dialog: 'contacts/tagForm/dialog',
      isUpdate: 'contacts/tagForm/isUpdate',
      isPersonal: 'contacts/tagForm/isPersonal',
      getTag: 'contacts/tagForm/tag'
    })
  },
  watch: {
    dialog (val) {
      if (val && this.getTag) {
        this.localTag = { ...this.getTag }
        this.originalName = this.localTag.name
      } else {
        this.localTag = null
        this.originalName = null
      }
    }
  },
  methods: {
    ...mapActions({
      createTag: 'contacts/tags/create',
      updateTag: 'contacts/tags/update',
      updatePersonalTag: 'contacts/personalTags/update',
      createPersonalTag: 'contacts/personalTags/create',
      setTag: 'contacts/tagForm/setTag',
      closeDialog: 'contacts/tagForm/close'
    }),

    submit () {
      if (this.isPersonal) {
        if (this.isUpdate) {
          this.updatePersonalTag(this.localTag)
        } else {
          this.createPersonalTag(this.localTag)
        }
      } else {
        if (this.isUpdate) {
          this.updateTag(this.localTag)
        } else {
          this.createTag(this.localTag)
        }
      }
      this.closeDialog()
    },

    close () {
      if (this.localTag) {
        this.localTag.name = this.originalName
      }
      this.closeDialog()
    }
  }
}
</script>

<style>

</style>
